import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { Helmet } from "react-helmet";

export default function CorporateBusinessTraining() {
  return (
    <>
      <Helmet>
        <title>
          Corporate Public Speaking Training Workshop | Public Speaking Academy
        </title>
        <meta
          name="description"
          content="Corporate Public Speaking Training Workshop led by top public speaker, Darren Tay."
        />
      </Helmet>

      <section id="breadcrumb" className="bg-[#F5F5FC] py-1">
        <div className="container mx-auto">
          <div className="flex flex-row justify-between mx-3">
            <div>CORPORATE / BUSINESS TRAINING</div>
            <div>
              Home / Corporate / School Training / Corporate/Business Training
            </div>
          </div>
        </div>
      </section>

      <section id="block-1" className="mx-3">
        <div class="container mx-auto py-20">
          <div class="flex flex-col lg:flex-row pt-5 space-x-10">
            <div class="w-full lg:w-2/3">
              <h1 class="font-primary text-2xl font-bold text-primary uppercase">
                Public Speaking Corporate Training & Group Training (for
                Businesses, Organizations, and Workplaces)
              </h1>
              <h2 class="font-primary text-xl font-bold text-primary uppercase py-5">
                Customised & Tailored Corporate Training to Inspire, Motivate,
                and Upskill Your Team, Company, or Business with Public Speaking
                / Effective Communication Skills
              </h2>
              <div>
                <img
                  src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-1-3-1.png"
                  alt=""
                />
                <div className="p-5 my-5 bg-orange-200 rounded-md ">
                  <svg
                    width="48"
                    height="34"
                    viewBox="0 0 48 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M44.0002 33.6666H34.0002L27.3335 20.3333V0.333313H47.3335V20.3333H37.3335L44.0002 33.6666ZM17.3335 33.6666H7.33349L0.666824 20.3333V0.333313H20.6668V20.3333H10.6668L17.3335 33.6666Z"
                      fill="#F17732"
                    />
                  </svg>
                  <h3 class="font-primary text-2xl font-bold text-primary text-center">
                    To upskill or not to upskill is no longer the question
                  </h3>
                  <p className="mb-10 text-lg text-center">
                    PWC, 23rd Annual Global CEO Survey
                  </p>
                </div>

                <p class="py-2 font-text text-lg font-bold">
                  “I want my team to be more confident in their networking,
                  meetings, and presentations.”
                </p>
                <p class="py-2 font-text text-lg">
                  At the workplace, your team members, colleagues, and staff are
                  the primary drivers of the company’s success. They are the
                  resources the modern company invests in to push for growth.
                  According to PWC’s 23rd Annual Global CEO Survey, the majority
                  of CEOs surveyed in 2019 agreed that “significant
                  retraining/upskilling was the most important way to close a
                  potential skills gap in their organisation”. As they framed
                  succinctly, to “upskill or not to upskill is no longer the
                  question”.
                </p>
                <p class="py-2 font-text text-lg">
                  <b>We want to help you achieve that success.</b> Public
                  speaking, communication or even persuasion skills are no
                  longer trivial “soft” skills. They are now a coveted skill-set
                  in the modern home, workplace, and world.
                </p>

                <h3 class="py-5 font-text text-2xl font-bold italic">
                  So, why the Public Speaking Academy?
                </h3>
                <p class="py-2 font-text text-lg">
                  The process of nurturing public speaking confidence can be a
                  daunting path. With Public Speaking Academy, we will bring you
                  expert and experienced communication training, driven by our
                  passion to help you present your voice to a wider audience and
                  dominate the business landscape. From 2009, and building on
                  our Master Trainer’s experience and methodology, we have been
                  conducting public speaking training in ensuring that you and
                  your team remain relevant, competitive and nimble.
                </p>
                <img
                  className="my-10"
                  src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-3.jpg"
                  alt=""
                />

                <p className="text-lg font-text">
                  With the Public Speaking Academy as your choice for a
                  communications corporate training provider, you will get:
                </p>
                <ul className="p-5 list-disc list-outside">
                  <li className="text-lg font-text">
                    <b>World Champion Experience:</b> Our programmes are helmed
                    by our quality and professional training faculty members,
                    each in high demand for expertise, accolades, and experience
                    in public speaking. Our training team is led by our Master
                    Trainer/Founder, Darren Tay, the World Champion of Public
                    Speaking in 2016, leveraging his experience in
                    speaking/training more than 250,000 individuals in effective
                    communication skills to utilise in the workplace and the
                    world.
                  </li>
                  <li className="text-lg font-text">
                    <b>Extensive Experience:</b> Our extensive experience in
                    public speaking stretches from 2009, growing to a total of 3
                    branches around Singapore. We have served SMEs, corporate
                    organisations, training companies, schools, and even
                    start-up incubators in customising public
                    speaking/communication solutions for their unique needs.
                  </li>
                  <li className="text-lg font-text">
                    <b>Customised Experience:</b> We draw from our extensive
                    syllabus and knowledge base to design a customised learning
                    experience that best fits your goals and budget – be it a
                    keynote, a masterclass, or a full public speaking
                    workshop/boot camp. Whether you are looking at developing
                    general public speaking confidence to specialised
                    communication corporate training (e.g., business
                    presentations, negotiation), we will work closely with you
                    to design a programme tailored to your company’s unique
                    learning and business needs.
                  </li>
                </ul>

                <h3 class="py-5 font-text text-2xl font-bold italic">
                  What is the Benefit for You & Your Company?
                </h3>
                <p className="text-lg font-text">
                  While every organisation/company carries a unique need, we are
                  versatile enough to reach into our knowledge and experience
                  bank to fill a gap you may have. We adopt a reasoned,
                  researched, and relevant approach in designing our programmes
                  that straddle a careful balance between (i) engaging theory
                  sharing (e.g., presentations on technique), and (ii) evaluated
                  practice sessions (e.g., practice presentations with
                  feedback). These are some examples of the programmes we have
                  conducted before:
                </p>
                <ul className="p-5 list-disc list-outside">
                  <li className="text-lg font-text">
                    <b>Team-Building Objective:</b> We have arranged public
                    speaking corporate training courses focusing on
                    story-crafting, brand-building, and general public speaking
                    confidence, to provide our participants the opportunity to
                    share their signature stories, inspire their teammates, and
                    practise their interpersonal communication skills in a safe
                    and constructive environment.
                  </li>
                  <li className="text-lg font-text">
                    <b>Upskill with Relevance:</b> We have listened to our
                    clients’ needs and identify precise and relevant skills to
                    help their team grow as competent, confident, and creative
                    communicators (e.g., impromptu speaking, pitching/sales
                    presentation skills, or online presentation techniques).
                    Invest in your team’s success today!
                  </li>
                  <li className="text-lg font-text">
                    <b>Leadership Potential:</b> Effective communication skills,
                    such as persuasion or conflict management, remain one of the
                    core leadership skills in a corporate setting. Whether it is
                    for your growth as part of the company’s management or to
                    ensure quality leadership development/renewal in your team,
                    our customised public speaking corporate training programmes
                    will help you reach that leadership potential!
                  </li>
                </ul>

                <p class="py-2 font-text text-lg">
                  We have covered a wide variety of topics, which include:
                </p>
                <p className="pt-5 pb-5 text-3xl font-bold text-center">
                  Topics Covered:
                </p>
                <img className="my-5" src="/images/topics-covered.jpg" alt="" />
                <p className="pt-5 pb-5 text-2xl italic font-bold font-primary">
                  Alright, I am in! What Now?
                </p>
                <p className="text-lg font-text">
                  We are excited to begin this journey with you to achieve
                  public speaking success! First, we would love to know more
                  about you and your team’s communication needs - feel free to
                  reach out to us through our Query Form to start the
                  conversation and curate your organization’s public speaking
                  training.
                </p>
                <p className="py-3 text-lg font-text">
                  We will be there with you as we design the best-fit programme
                  to develop your team into highly effective public speakers at
                  work, empowered with charisma, influence, and impact!
                </p>
                <p className="py-3 text-lg font-bold font-text">
                  In reaching out to us, it would be helpful to share these
                  preliminary information to help us understand how best to
                  start:
                </p>

                <ul className="p-5 list-disc list-outside">
                  <li className="text-lg font-text">
                    Total number of participants
                  </li>
                  <li className="text-lg font-text">
                    Total duration (estimated)
                  </li>
                  <li className="text-lg font-text">
                    Nature of programme (e.g., 1-day, masterclasses, regular
                    sessions)
                  </li>
                  <li className="text-lg font-text">
                    Total number of trainers required
                  </li>
                  <li className="text-lg font-text">
                    Total duration of training (including time distribution,
                    e.g., 18 hours of instruction, over 2 days or 4 days)
                  </li>
                  <li className="text-lg font-text">
                    Summary of the learning objectives
                  </li>
                  <li className="text-lg font-text">
                    Preferred training venue (at one of our learning centres or
                    on-site)
                  </li>
                  <li className="text-lg font-text">
                    Estimated budget for the assignment
                  </li>
                </ul>
              </div>

              <div className="bg-slate-50 p-2 md:p-10 ">
                <div className=" mb-10">
                  <h1 className="divider text-primary font-primary font-bold uppercase text-2xl md:text-3xl">
                    END OF COURSE DETAILS
                  </h1>
                  <h1 className="text-slate-500 font-primary font-bold text-center text-xl md:text-2xl">
                    Quick Tips
                  </h1>
                </div>

                <div
                  tabIndex={0}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🗣️ How to Speak Clearly and Professionally
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      To speak clearly and professionally means expressing your
                      ideas in a way that’s easy to follow and leaves a good
                      impression.
                    </p>
                    <p className="py-1">Here’s how to do it:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">1. Slow down</p>
                      <p className="font-text">
                        Speaking too fast can confuse your audience. Aim for a
                        natural pace. Moderate rate of speaking is about 2-3
                        words per second.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Enunciate words
                      </p>
                      <p className="font-text">
                        Practice crisp, clear pronunciation—especially of key
                        terms.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Trim the fillers
                      </p>
                      <p className="font-text">
                        Reduce "um", "like", and "you know". Silence is better
                        than a filler.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Use simple language
                      </p>
                      <p className="font-text">
                        Big words aren’t impressive if they cause confusion.
                        Clarity wins.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Practice vocal variety
                      </p>
                      <p className="font-text">
                        Change your tone and pitch to avoid sounding flat or
                        robotic.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={1}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧩 How to Organize a Speech Quickly
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      When time is tight, a solid structure saves the day. Use
                      the tried-and-true <b>“Point, Reason, Example”</b> format.
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Start with your point
                      </p>
                      <p className="font-text">
                        What’s the key message or takeaway? One thing that even
                        if your audience forgets everything else BUT{" "}
                        <b>this!</b>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Add your reason
                      </p>
                      <p className="font-text">
                        Why does it matter? Back it up with logic or context.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Give an example
                      </p>
                      <p className="font-text">
                        Stories or real-life applications make your message
                        stick.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Close with a recap
                      </p>
                      <p className="font-text">
                        Reinforce your main point and end confidently.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={2}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    💬 How to Build Confidence in Adult Introverts for
                    Presentations
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Introverts can be powerful presenters—when they learn to
                      harness calm, focused communication.
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Reframe the purpose
                      </p>
                      <p className="font-text">
                        Shift focus to how your speech is going to benefit the
                        audience, not performing for them or for them to judge
                        you.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Prepare and practice deeply
                      </p>
                      <p className="font-text">
                        Introverts tend to thrive with structure. Rehearse until
                        the content feels second nature. Internalize with
                        sign-posting (…after delivering the <b>‘challenges’</b>,
                        now comes the <b>‘solutions’</b>…)
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Use strengths like clarity and thoughtfulness
                      </p>
                      <p className="font-text">
                        You don’t have to be flashy. A quiet, well-paced
                        delivery can be just as compelling.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Start with low-pressure settings
                      </p>
                      <p className="font-text">
                        Try small team meetings, Zoom calls, or one-on-one
                        presentations first.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Learn breathing and grounding techniques
                      </p>
                      <p className="font-text">
                        Simple tools like pursed-lips breathing (Feeling the
                        cool air up the nose when inhaling, and slowly exhaling
                        with pursed lips) or pausing with sustained eye contact
                        before you speak can keep nerves in check.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={3}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧠 How to Handle Difficult Questions in Business
                    Presentations
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Tough questions during a presentation can feel
                      intimidating—but they’re actually a chance to show
                      credibility and calm under pressure.
                    </p>
                    <p className="py-1">Here's how to do it:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Stay calm and listen fully
                      </p>
                      <p className="font-text">
                        Don’t interrupt. Take a breath to process before you
                        reply.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Clarify if needed
                      </p>
                      <p className="font-text">
                        If the question is vague or aggressive, reframe it:
                        “Just to clarify—are you asking about…?”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Acknowledge the concern
                      </p>
                      <p className="font-text">
                        A simple “That’s a valid point” shows respect and
                        professionalism despite any disagreement with the
                        argument.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Answer concisely
                      </p>
                      <p className="font-text">
                        Stick to facts. If you don’t know, it’s okay to say:
                        “I’ll check on that and get back to you.”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Redirect to your main message
                      </p>
                      <p className="font-text">
                        Bring the audience back to your key takeaway: “The KEY
                        point I’m trying to make is…”
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={4}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🎯 Communication Skills Training for Managers and Team
                    Leaders
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Strong communication helps leaders motivate, align, and
                      build trust with their teams.
                    </p>
                    <p className="py-1">Key areas to develop:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Clarity of message
                      </p>
                      <p className="font-text">
                        Leaders should exercise economy of words – always strive
                        for clarity and conciseness.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Active listening
                      </p>
                      <p className="font-text">
                        Hear your team out— discover underlying concerns and
                        then respond with empathy and relevance.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Giving feedback
                      </p>
                      <p className="font-text">
                        Offer constructive feedback that contains actionable
                        steps that support progress, not just correction or
                        worse, condemnation.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Speaking with presence
                      </p>
                      <p className="font-text">
                        Your voice, tone, and body language should project calm
                        and confidence.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Handling tough conversations
                      </p>
                      <p className="font-text">
                        Training helps leaders stay composed and fair—even under
                        pressure.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={5}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧩 What Are Effective Public Speaking Techniques for Sales
                    Professionals
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Sales professionals rely on strong speaking skills to
                      build trust and close deals.
                    </p>
                    <p className="py-1">
                      Here’s how to speak more persuasively in sales settings:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Focus on the listener's needs
                      </p>
                      <p className="font-text">
                        Start with their pain points—not your product. Frame
                        your message as a solution (instead of harping on
                        features, focus on benefits; e.g. the AI-assisted app
                        feature can save 30% time and cost, boosting
                        productivity)
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Use clear, benefit-driven language
                      </p>
                      <p className="font-text">
                        Explain how your product helps in real-world terms.
                        Avoid jargon.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Tell client success stories
                      </p>
                      <p className="font-text">
                        Share short, authentic testimonials of how others
                        benefited.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Practice objection handling
                      </p>
                      <p className="font-text">
                        Stay calm when prospects push back—acknowledge, decipher
                        underlying concerns, answer, and refocus.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Project confidence and energy
                      </p>
                      <p className="font-text">
                        Your tone (reassuring), posture (ready to serve), and
                        sustained eye contact all help build rapport.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={6}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    💼 How to Develop Executive Presence
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Executive presence is that "something" that makes people
                      stop and listen—it’s a mix of communication, confidence,
                      and calm.
                    </p>
                    <p className="py-1">Here’s how to build it:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Speak with confidence
                      </p>
                      <p className="font-text">
                        Use a steady pace, strong voice, and clear structure
                        when you talk. Pause if need be, instead of using pause
                        fillers.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Master non-verbal signals
                      </p>
                      <p className="font-text">
                        Stand tall (chest upright & outwards), make sustained
                        eye contact, and use purposeful gestures.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Listen before you speak
                      </p>
                      <p className="font-text">
                        Show respect by tuning in, then responding thoughtfully.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Stay composed, and always be clear on core interests
                        whilst under pressure
                      </p>
                      <p className="font-text">
                        When things get tough, your calm energy sets the tone.
                        Never lose sight of your organization’s core interests
                        even when sense of urgency is required.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Lead with vision
                      </p>
                      <p className="font-text">
                        Speak not just to inform—but to inspire.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={6}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧭 Is Public Speaking a Leadership Skill?
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Yes—public speaking is a core leadership skill. Leaders
                      need to inform, inspire, and influence others—and strong
                      speaking skills help make that happen.
                    </p>
                    <p className="py-1">Here’s why it matters:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Builds trust and credibility
                      </p>
                      <p className="font-text">
                        Clear, confident speech helps leaders earn respect and
                        command attention.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Clarifies vision and direction
                      </p>
                      <p className="font-text">
                        Great leaders communicate goals and values in a way that
                        rallies others to act.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Inspires and motivates
                      </p>
                      <p className="font-text">
                        Storytelling, tone, and presence can ignite team morale
                        and momentum.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Navigates tough conversations
                      </p>
                      <p className="font-text">
                        Whether it’s delivering feedback or handling crisis,
                        effective speaking keeps people aligned.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Boosts influence and visibility
                      </p>
                      <p className="font-text">
                        The ability to speak well in public settings—from
                        meetings to keynotes—amplifies leadership impact.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={7}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🔁 Difference Between Impromptu and Prepared Speech
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      <b>Impromptu speeches</b> are delivered with little to no
                      preparation—think of answering a surprise question in
                      class or during a meeting.
                      <br />
                      <b>Prepared speeches</b> are written, practiced, and
                      rehearsed ahead of time—like a TED Talk or school
                      classroom/ business/ boardroom presentation.
                    </p>
                    <p className="py-1">Here’s a quick comparison:</p>
                    <div className="py-5">
                      <table className="table-auto w-full text-left border">
                        {/* head */}
                        <thead>
                          <tr className="bg-slate-200">
                            <th>Aspect</th>
                            <th>Impromptu Speech</th>
                            <th>Prepared Speech</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* row 1 */}
                          <tr>
                            <td>Planning time</td>
                            <td>Minimal or none</td>
                            <td>Ample time to plan</td>
                          </tr>
                          {/* row 2 */}
                          <tr>
                            <td>Structure</td>
                            <td>Often spontaneous</td>
                            <td>Clear and deliberate</td>
                          </tr>
                          {/* row 3 */}
                          <tr>
                            <td>Delivery</td>
                            <td>Natural, conversational</td>
                            <td>Polished, rehearsed</td>
                          </tr>
                          {/* row 4 */}
                          <tr>
                            <td>Examples</td>
                            <td>Q&A sessions, interviews, oral exams</td>
                            <td>Keynotes, speeches, presentations</td>
                          </tr>
                          {/* row 5 */}
                          <tr>
                            <td>Skill focus</td>
                            <td>Thinking fast on your feet</td>
                            <td>Clarity, depth, delivery style</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p className="py-1">
                      Both styles build different communication muscles—and
                      strong speakers often train in both.
                    </p>
                  </div>
                </div>

                <div
                  tabIndex={6}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🎯 Presentation Skills Training Course for Adults
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      <b>A presentation skills training course for adults</b>{" "}
                      helps professionals communicate clearly, confidently, and
                      persuasively—whether in meetings, on stage, or online. It
                      should offer a deep-dive into public speaking and business
                      presentation techniques, tailored to the modern working
                      adult.
                    </p>
                    <p className="py-1">
                      Here’s what a good presentation course typically covers:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Building speaking confidence
                      </p>
                      <p className="font-text">
                        <ul className="list-outside pl-5">
                          <li className="list-disc">
                            Teaches effective power poses you can use to
                            overcome stage fright and business presentation
                            anxieties.
                          </li>
                          <li className="list-disc">
                            Guides students through step-by-step visualization
                            method to be consistently confident in public
                            speaking settings.
                          </li>
                          <li className="list-disc">
                            How to rehearse & practice like the top professional
                            speakers.
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Structuring a compelling presentation
                      </p>
                      <p className="font-text">
                        <ul className="list-outside pl-5">
                          <li className="list-disc">
                            How to compose an attention-grabbing story
                          </li>
                          <li className="list-disc">
                            The secrets to delivering powerful powerpoint
                            presentation without reading off the slides
                          </li>
                          <li className="list-disc">
                            The "8-step Edge of the seat" formula that keeps
                            peoples listening attentively plus 2 speech genres
                            (persuasive and informative speech)
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Improving vocal delivery and body language
                      </p>
                      <p className="font-text">
                        Have adult learners practice eye contact, tone
                        variation, gestures, and posture to create presence.
                      </p>
                      <p className="font-text">
                        <ul className="list-outside pl-5">
                          <li className="list-disc">
                            Hand gestures,power poses, stage positioning fright
                          </li>
                          <li className="list-disc">
                            How to have stage presence with proper eye contact
                            (learn about the wide angle of attack and eye
                            contact distribution)
                          </li>
                          <li className="list-disc">
                            The power of incorporating pauses in your
                            presentation
                          </li>
                          <li className="list-disc">
                            Facial expressions you should avoid using
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Practising with real exposure to unfamiliar audience
                      </p>
                      <p className="font-text">
                        Deliver speeches in breakout sessions & final showcase
                        to accumulate stage mileage, in front of classmates from
                        all walks of life, get insightful trainer’s feedback,
                        and apply techniques in work-related contexts.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Personalized feedback/ evaluation
                      </p>
                      <p className="font-text">
                        The best presentation skills training programs offer
                        personalized guidance and evaluation to help you improve
                        & develop faster.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden lg:inline w-1/3 px-5 pt-5 mb-10 border border-dashed rounded-lg">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
